import {setGlobal} from '@netx/core-next/utils/setGlobal';

export const Menus: any = {};

// because... well, take a guess
setGlobal((Netx) => ({
	...Netx,
	Menus,
}));

export const addMenus = (menus: any) => {
	Object.assign(Menus, menus);
};

export default Menus;
